import React, { useEffect } from 'react';
import Typography from '@material-ui/core/Typography';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';

export default function TankAndDischargement(props) {
  const { wagonTechnicalDetails, classes, expanded, handleChange } = props;
  const [wagonTechnicalDetailsState, setWagonTechnicalDetailsState] =
    React.useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (wagonTechnicalDetails !== undefined) {
      setWagonTechnicalDetailsState(wagonTechnicalDetails);
    }
  }, [wagonTechnicalDetails]);
  return (
    <div>
      {wagonTechnicalDetailsState && (
        <Accordion
          className={classes.accordion}
          expanded={expanded}
          onChange={handleChange}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon className={classes.expandIcon} />}
          >
            <Typography className={classes.heading}>
              {t('Tank & dischargment')}
            </Typography>
            <Typography className={classes.secondaryHeading}>
              {t('Details about tank & dischargement')}
            </Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.accordionDetails}>
            <div className={classes.container}>
              <Grid container spacing={1} className={classes.gridMargin}>
                <Grid item xs={2}>
                  <FormLabel className={classes.formLabel}>
                    {t('TANK code')}
                  </FormLabel>
                </Grid>
                <Grid item xs={2}>
                  <FormLabel className={classes.formLabel}>
                    {t('Top discharge')}
                  </FormLabel>
                </Grid>
                <Grid item xs={2}>
                  <FormLabel className={classes.formLabel}>
                    {t('Material joint dome')}
                  </FormLabel>
                </Grid>
                <Grid item xs={2}>
                  <FormLabel className={classes.formLabel}>
                    {t('Safety valve')}
                  </FormLabel>
                </Grid>
                <Grid item xs={2}>
                  <FormLabel className={classes.formLabel}>
                    {t('Prevent vacuum valve')}
                  </FormLabel>
                </Grid>
                <Grid item xs={2}>
                  <FormLabel className={classes.formLabel}>
                    {t('Vapour recovery pipe')}
                  </FormLabel>
                </Grid>
                <Grid item xs={2}>
                  <FormLabel className={classes.wagonNumberStyle}>
                    {wagonTechnicalDetailsState.tankCode !== null &&
                    wagonTechnicalDetailsState.tankCode !== ''
                      ? wagonTechnicalDetailsState.tankCode
                      : '-'}
                  </FormLabel>
                </Grid>
                <Grid item xs={2}>
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.topDischarge !== null
                      ? wagonTechnicalDetailsState.topDischarge === false
                        ? t('no')
                        : t('yes')
                      : '-'}
                  </FormLabel>
                </Grid>
                <Grid item xs={2}>
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.materialJointDome !== null &&
                    wagonTechnicalDetailsState.materialJointDome !== ''
                      ? wagonTechnicalDetailsState.materialJointDome
                      : '-'}
                  </FormLabel>
                </Grid>
                <Grid item xs={2}>
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.safetyValve !== null
                      ? wagonTechnicalDetailsState.safetyValve === false
                        ? t('no')
                        : t('yes')
                      : '-'}
                  </FormLabel>
                </Grid>
                <Grid item xs={2}>
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.preventVaccumValve !== null
                      ? wagonTechnicalDetailsState.preventVaccumValve === false
                        ? t('no')
                        : t('yes')
                      : '-'}
                  </FormLabel>
                </Grid>
                <Grid item xs={2}>
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.vapourRecoveryPipe !== null
                      ? wagonTechnicalDetailsState.vapourRecoveryPipe === false
                        ? t('no')
                        : t('yes')
                      : '-'}
                  </FormLabel>
                </Grid>
              </Grid>
              <Grid container spacing={1} className={classes.gridMargin}>
                <Grid item xs={2}>
                  <FormLabel className={classes.formLabel}>
                    {t('Coupling gas phase')}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel}>
                    {t('Coupling liquid phase')}
                  </FormLabel>
                </Grid>
                <Grid item xs={2}>
                  <FormLabel className={classes.formLabel}>
                    {t('Coupling steam in')}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.formLabel}>
                    {t('Coupling condensate out')}
                  </FormLabel>
                </Grid>
                <Grid item xs={2}>
                  <FormLabel className={classes.formLabel}>
                    {t('Bottom discharge')}
                  </FormLabel>
                </Grid>
                <Grid item xs={2}>
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.couplingGasPhase !== null &&
                    wagonTechnicalDetailsState.couplingGasPhase !== ''
                      ? wagonTechnicalDetailsState.couplingGasPhase
                      : '-'}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.couplingLiquidPhase !== null &&
                    wagonTechnicalDetailsState.couplingLiquidPhase !== ''
                      ? wagonTechnicalDetailsState.couplingLiquidPhase
                      : '-'}
                  </FormLabel>
                </Grid>
                <Grid item xs={2}>
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.couplingSteamIn !== null
                      ? wagonTechnicalDetailsState.couplingSteamIn === false
                        ? t('no')
                        : t('yes')
                      : '-'}
                  </FormLabel>
                </Grid>
                <Grid item xs={3}>
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.couplingCondensateOut !== null
                      ? wagonTechnicalDetailsState.couplingCondensateOut ===
                        false
                        ? t('no')
                        : t('yes')
                      : '-'}
                  </FormLabel>
                </Grid>
                <Grid item xs={2}>
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.bottomDischarge !== null
                      ? wagonTechnicalDetailsState.bottomDischarge === false
                        ? t('no')
                        : t('yes')
                      : '-'}
                  </FormLabel>
                </Grid>
                <Grid
                  item
                  xs={6}
                  container
                  justify="center"
                  alignItems="center"
                >
                  <FormLabel className={classes.formLabel}>
                    {t('Complete emptying')}
                  </FormLabel>
                </Grid>
                <Grid item xs={6}>
                  <FormLabel className={classes.formLabel}>
                    {t('Distance gas liquid valve')}
                  </FormLabel>
                </Grid>
                <Grid
                  item
                  xs={6}
                  container
                  justify="center"
                  alignItems="center"
                >
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.completeEmptying !== null
                      ? wagonTechnicalDetailsState.completeEmptying === false
                        ? t('no')
                        : t('yes')
                      : '-'}
                  </FormLabel>
                </Grid>{' '}
                <Grid item xs={6}>
                  <FormLabel className={classes.wagonDetail}>
                    {wagonTechnicalDetailsState.distanceGasLiquidValve !== null
                      ? wagonTechnicalDetailsState.distanceGasLiquidValve
                      : '-'}
                  </FormLabel>
                </Grid>
              </Grid>
            </div>
          </AccordionDetails>
        </Accordion>
      )}
    </div>
  );
}
